// =============================================================================
// MOCK DATA CONSTANTS
// =============================================================================

// Mock Candidate Data (for testing purposes)
export const MOCK_CANDIDATE_DATA = {
  fullName: "John Doe",
  email: "test1@gmail.com",
  phone: "+44444444444",
  mobile: "+1111111111",
  totalExperience: "10",
  relevantExperience: "3",
  resumeLastUpdated: "2025-09-16",
  gender: "Male",
  jobStabilityRating: 9,
  jobChangeInLast5Years: true,
  blackListed: false,
  maxTravelDistance: 25,
  dateAvailable: "2024-10-01T00:00:00.000Z",
  noticePeriod: "2 Weeks",
  agency: {
    name: "ISG Talent Solutions",
    sfdcId: "aEGVp000000zKhiOAE"
  },
  onboardingStatus: "Not Started",
  doNotContact: {
    email: false,
    phone: false,
    sms: false,
    whatsapp: false
  },
  contactPreferences: {
    email: true,
    phone: true,
    sms: true,
    whatsapp: true
  },
  jobboardSource: {
    jobboardName: "ISG Talent Portal",
    sfdcId: "aEGVp000000zKhlOAE"
  },
  jobPreference: {
    openToRelocate: false,
    openToOnsite: false,
    openToRemote: false,
    titleMatchCriteria: ["AI/ML Engineer", "Machine Learning Engineer", "Data Scientist", "AI Engineer", "ML Engineer"]
  },
  profileCompleteness: [
    {
      category: "Personal Information",
      weightage: 10,
      isComplete: true
    },
    {
      category: "Registration",
      weightage: 15,
      isComplete: true
    }
  ],
  completenessPercentage: 85,
  skills: [
    {
      title: "Python",
      level: "3"
    },
    {
      title: "SQL",
      level: "3"
    }
  ],
  employmentHistory: [
    {
      employerName: "CitiGroup",
      startDate: "2024-06-01T00:00:00.000Z",
      currentlyWorking: false,
      jobTitle: "AI/ML Engineer"
    },
    {
      id: "68a394ae3fbfce94f101d005",
      employerName: "Simform",
      startDate: "2020-06-01T00:00:00.000Z",
      endDate: "2022-06-01T00:00:00.000Z",
      currentlyWorking: false,
      jobTitle: "ML Engineer"
    }
  ],
  educations: [
    {
      degree: "Masters in Data Science  Analytics",
      startDate: "2024-05-01T00:00:00.000Z",
      endDate: "2024-05-01T00:00:00.000Z",
      institute: {
        label: "State University of New York, Albany, New York, USA",
        value: "State University of New York, Albany, New York, USA",
        key: "State University of New York, Albany, New York, USA"
      }
    },
    {
      title: "Bachelor of technology in Electronics and Communication Engineering",
      startDate: "2016-05-01T00:00:00.000Z",
      endDate: "2020-05-01T00:00:00.000Z",
      institute: "Anurag Group of Institutions (JNTU-H Affiliated), Hyderabad, India"
    }
  ],
  certifications: [
    {
      name: "AWS Certified Machine Learning - Specialty",
      expirationDate: "2025-08-01T00:00:00.000Z",
      certificationNumber: "00111aws-ml-specialty",
      issuingAuthority: "Amazon Web Services (AWS)"
    }
  ],
  preferredLanguage: "English",
  socialLinks: [
    {
      name: "LinkedIn",
      profileLink: "http://linkedin.com/in/someone-s-47376"
    }
  ],
  languages: [
    {
      name: "English",
      proficiency: "Read"
    }
  ],
  about: "AI/ML Engineer with 3+ years of experience designing and deploying applied AI solutions and machine learning models in enterprise environments. Skilled in building end-to-end ML pipelines, fine-tuning LLMs, and applying modern MLOps practices to scale AI in production. Proven record in financial services (credit risk, fraud detection, compliance automation) and consulting projects (retail, SaaS). Strong background in regulated environments with model governance, monitoring, and explainability.",
  address: {
    country: "USA",
    state: "NY",
    zip: "10001",
    city: "New York"
  },
  title: "AI/ML Engineer",
  preferredLocations: ["New York, NY, USA"],
  reasonForChange: "Looking for new challenges and opportunities to work on cutting-edge AI/ML projects in a collaborative environment."
} as const;

